/**
 * Visual QA mode. NOT the shipped dashboard.
 *
 * `017` dropped nine dashboard widgets and left every list empty without a backend, because FR-020
 * and constitution VI forbid showing a figure the API did not return. That still stands **for
 * production**. This is the stated, bounded exception: with the flag on, screens render the
 * template's own demo data so the design can be reviewed offline.
 *
 * ## Why it cannot ship on by accident
 *
 * Two conditions, and the first is not settable in a production build:
 *
 *   `import.meta.env.DEV`      - Vite replaces this with the literal `false` when it builds for
 *                                production. The `&&` then folds to `false` at compile time and
 *                                Rollup drops every demo-data import from the bundle entirely, so
 *                                the demo rows are not merely hidden, they are not shipped.
 *   `VITE_DEMO_DATA === "1"`   - and a developer still has to ask for it, so `pnpm dev` alone
 *                                shows the real (sparse) screens, which stay the default.
 *
 * `guards.test.ts` check 8 asserts both halves: that the flag is off without the env var, and that
 * the production expression is statically false.
 *
 * ## The rules that come with it
 *
 * - Demo data comes from `packages/theme/src/data/**` and nowhere else.
 * - A component fed by it renders a visible "Demo data" marker (rizzui `Badge`), so nothing on
 *   screen is ambiguous about where its numbers came from.
 * - It is never mixed into a component that also renders real API data. A screen is either
 *   showing the API's answer or showing the template's demo rows, never a blend of the two.
 */
export const DEMO_DATA_ENABLED: boolean =
  import.meta.env.DEV === true && import.meta.env.VITE_DEMO_DATA === "1";

/** Demo rows in visual QA mode, nothing otherwise. The seam every `src/data/**` module goes through. */
export function demoOnly<T>(rows: T[]): T[] {
  return DEMO_DATA_ENABLED ? rows : [];
}
